package pwgs.ui.scenes.diagnosticsissuelistscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class ADiagnosticsIssueListControllerFe(props: pwgs.ui.scenes.diagnosticsissuelistscene.DiagnosticsIssueListSceneProps, scene: MDiagnosticsIssueListScene)
 : AController<pwgs.ui.scenes.diagnosticsissuelistscene.DiagnosticsIssueListSceneProps, pwgs.ui.scenes.diagnosticsissuelistscene.DiagnosticsIssueListSceneModel, DiagnosticsIssueListSceneState>(props, scene) {

    val backend = DiagnosticsIssueListControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class DiagnosticsIssueListControllerBeProxy(private val controller: ADiagnosticsIssueListControllerFe) {

    suspend fun load(): pwgs.ui.scenes.diagnosticsissuelistscene.DiagnosticsIssueListSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.diagnosticsissuelistscene.DiagnosticsIssueListControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.diagnosticsissuelistscene.DiagnosticsIssueListSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.diagnosticsissuelistscene.DiagnosticsIssueListSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.diagnosticsissuelistscene.DiagnosticsIssueListSceneModel.serializer())
        }
    }

}
